import { render, staticRenderFns } from "./coworking.html?vue&type=template&id=0fc8b677&scoped=true&"
import script from "./coworking.js?vue&type=script&lang=js&"
export * from "./coworking.js?vue&type=script&lang=js&"
import style0 from "./coworking.scss?vue&type=style&index=0&id=0fc8b677&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc8b677",
  null
  
)

export default component.exports